<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('港澳') " style='width:120px'>
              <Option :value="'0'">{{ $t('新澳门') }}</Option>
              <Option :value="'1'">{{ $t('香港') }}</Option>
              <Option :value="'2'">{{ $t('老澳门') }}</Option>
              <Option :value="'3'" >{{ $t('新加坡') }}</Option>
              <Option :value="'4'" >{{ $t('柬埔寨') }}</Option>
              <Option :value="'5'" >{{ $t('台湾') }}</Option>
              <Option :value="'6'" >{{ $t('印尼') }}</Option>
              <Option :value="'7'" >{{ $t('马来西亚') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->

          <!-- DATA -->
          <div>
            <div><p style="color: red;text-align: left;font-size: 20px">当前帖子总数量:{{total}}</p></div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>



  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [ {
        title: '序号',
        type: 'index',
        width: 65,
        align: 'center'
      },{
        title: this.$t('港澳'),
        align: 'center',
        width: 110,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.isXg != 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.isXg != 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, this.getGameName(params.row.isXg))])
        }
      },{
        title: this.$t('类型'),
        key: 'category',

        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('当前数量'),
        key: 'nowNum',
        minWidth: 120,
        align: 'center'
      }, {
        title: '最大数量',
        sortable: true,
        key: 'maxNum',
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.maxNum,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/categoryNumSet', {id:params.row.id,maxNum:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      }],
      total:0,
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------

      //弹窗--------------
      windowPL: { //弹窗
        show: false,
        loading: false,
        index: 0,
        isOut:false
      },

      windowPLItem: { //弹窗数据绑定
        id: 0
      },
      windowPLValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcOpenLog/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted() {
    this.getParams()
  },
  methods: {
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.author='';
      vm.windowAddItem.signature='';
      vm.windowAdd.show = true
    },



    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getGameName(isXg){
      if(isXg==0){
        return "新澳门";
      }else  if(isXg==1){
        return "香港";
      }else  if(isXg==2){
        return "老澳门";
      }else  if(isXg==3){
        return "新加坡";
      }else  if(isXg==4){
        return "柬埔寨";
      }else  if(isXg==5){
        return "台湾";
      }else  if(isXg==6){
        return "印尼";
      }else  if(isXg==7){
        return "马来西亚";
      }
      return ""
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      customPost('Lhc/categoryNumList', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.total=response.data.data.total
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          customPost('Lhc/authorUpdateOrCreate',vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },

    windowPLCancel(data) {
      if (!data) {
        this.windowPLItem.id = 0
        this.$refs['windowPLForm'].resetFields()
        this.windowPL.show = false
        this.windowPL.loading = false
        this.windowPL.index = 0
      }
    }, windowPLSubmit() {
      let vm = this
      vm.$refs['windowPLForm'].validate((valid) => {
        if (valid) {
          vm.windowPL.loading = true
          vm.windowPLItem.isIn=1
          customPost('Lhc/authorInAndOutAll', vm.windowPLItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowPLCancel()
          })

        }
      })
    }

  }
}
</script>
